module.exports = __webpack_public_path__ + "static/media/help.9d6ccae3.svg";